import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IContentSection } from '../../../../shared/interfaces/card-info.interface';
import { RevealDirective } from '../../../../shared/directives/reveal.directive';
import { SpotlightDirective } from '../../../../shared/directives/spotlight.directive';

@Component({
  selector: 'app-lead-section',
  imports: [RouterLink, RevealDirective, SpotlightDirective],
  templateUrl: './lead-section.html',
  styleUrl: './lead-section.scss'
})
export class LeadSection {
  /** Supplies heading + lead/outro copy (kept in landing-sections.ts so copy never drifts). */
  @Input({ required: true }) section!: IContentSection;

  /** Which side the big heading column hugs. */
  @Input() headingAlign: 'left' | 'right' = 'left';

  /** Wrap the content in a frosted-glass card. */
  @Input() card = false;

  /** 'split' = heading one side / copy the other; 'center' = heading + copy centered. */
  @Input() layout: 'split' | 'center' = 'split';

  /** Optional destination for the section heading (links to the matching service page). */
  @Input() link?: string;

  /** All body paragraphs (lead + outro), minus any "Services include:" eyebrow line. */
  get paragraphs(): string[] {
    const lead = this.section.lead ?? [];
    const outro = this.section.outro ?? [];
    return [...lead, ...outro].filter((p) => !/^\s*services include/i.test(p));
  }
}
